<template>
  <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 17.4667H13.3333M6.66667 9.55005L6.66667 3.56321M6.66667 14.6158L2.72758 10.8063C1.59094 9.70708 0.952381 8.21617 0.952381 6.66159V6.32636C0.952381 3.27426 3.51075 0.800049 6.66667 0.800049C9.82258 0.800049 12.381 3.27427 12.381 6.32637V6.66159C12.381 8.21617 11.7424 9.70708 10.6058 10.8063L6.66667 14.6158Z"
      stroke="currentColor"
      stroke-width="1.6"
    />
  </svg>
</template>
